<template>
  <nav>
    <ul>
      <li class="crumb">
        <router-link to="/">
          <span>Accueil</span>
        </router-link>
      </li>
      <li class="crumb">
        <router-link to="/reiki">
          <span>Reiki</span>
        </router-link>
      </li>
      <li class="crumb">
        <router-link to="/massage">
          <span>Massage 5 continents</span>
        </router-link>
      </li>
      <li class="crumb">
        <router-link to="/shiatsu">
          <span>Shiatsu</span>
        </router-link>
      </li>
      <li class="crumb">
        <router-link to="/lahochi">
          <span>LaHoChi</span>
        </router-link>
      </li>
      <li class="crumb soon">
        <router-link to="/reflexologie">
          <span>Réflexologie</span>
        </router-link>
      </li>
      <li class="crumb soon">
        <router-link to="/maison">
          <span>Nettoyage lieux</span>
        </router-link>
      </li>
      <li class="crumb soon">
        <router-link to="/formation">
          <span>Formation LaHoChi</span>
        </router-link>
      </li>
      <li class="crumb">
        <router-link to="/contact-essars">
          <span>Tarifs</span>
        </router-link>
      </li>
      <li class="crumb">
        <router-link to="/gift">
          <span>Chèque Cadeau</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
  export default {
    name: 'AppNavbar'
  }
</script>

<style lang="scss" scoped>
  nav {
    position: relative;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    ul {
      display: flex;

      li {
        display: flex;
        margin: 0 1em;

        a {
          color: $color-grey;
          display: flex;
          cursor: pointer;
          font-weight: 700;
          border-bottom: 2px solid #fbf6f1;

          &:hover, &.router-link-exact-active {
            color: $color-green;
            border-bottom: 2px solid $color-green;
          }

          img {
            width: 3em;
          }
        }
      }
    }
  }

</style>
